export default "__VITE_ASSET__BgRNc6qb__"